"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  PermissionsCheck: () => PermissionsCheck,
  ResourceInfoContext: () => ResourceInfoContext,
  ResourceInfoWrapper: () => ResourceInfoWrapper,
  ResourcePermissions: () => import_api_client2.ResourcePermissions,
  ResourceType: () => import_api_client2.ResourceType,
  useHasPermission: () => useHasPermission,
  usePermissionCheck: () => usePermissionCheck,
  useResourceInfo: () => useResourceInfo
});
module.exports = __toCommonJS(src_exports);

// src/hooks/useHasPermissions.ts
var import_api_client = require("@repo/api-client");
var useHasPermission = (permission, resourceType, resourceId) => {
  const permissionQuery = (0, import_api_client.useResourcePermissionsQuery)({
    resourceType,
    resourceId
  });
  const { data, isLoading } = permissionQuery;
  if (isLoading) {
    return void 0;
  }
  const hasPermission = data?.permissions?.[permission] ?? false;
  return hasPermission;
};

// src/hooks/useResourceInfo.tsx
var import_react = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var ResourceInfoContext = (0, import_react.createContext)({});
var ResourceInfoWrapper = ({
  children,
  ...resources
}) => {
  const parentContext = (0, import_react.useContext)(ResourceInfoContext);
  const contextValue = (0, import_react.useMemo)(() => {
    const map = { ...parentContext };
    Object.entries(resources).forEach(([type, id]) => {
      if (id !== void 0) {
        map[type] = {
          resourceType: type,
          resourceId: id
        };
      }
    });
    return map;
  }, [resources, parentContext]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ResourceInfoContext.Provider, { value: contextValue, children });
};
var useResourceInfo = (type) => {
  const context = (0, import_react.useContext)(ResourceInfoContext);
  const resource = context[type];
  if (!resource) {
    return {};
  }
  return resource;
};

// src/hooks/usePermissionCheck.ts
function usePermissionCheck(requires, resourceType) {
  const { resourceId: resourceIdFromContext } = useResourceInfo(resourceType);
  const hasPermission = useHasPermission(
    requires,
    resourceType,
    resourceIdFromContext
  );
  return {
    hasPermission,
    resourceId: resourceIdFromContext,
    isLoading: hasPermission === void 0
  };
}

// src/components/PermissionsCheck.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var PermissionsCheck = ({
  requires,
  resourceType,
  children,
  fallback = null,
  loader = null
}) => {
  const { hasPermission, isLoading } = usePermissionCheck(
    requires,
    resourceType
  );
  if (isLoading) {
    return loader;
  }
  if (!hasPermission) {
    return fallback;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_jsx_runtime2.Fragment, { children });
};

// src/constants.ts
var import_api_client2 = require("@repo/api-client");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  PermissionsCheck,
  ResourceInfoContext,
  ResourceInfoWrapper,
  ResourcePermissions,
  ResourceType,
  useHasPermission,
  usePermissionCheck,
  useResourceInfo
});
